import { SVGProps } from 'react';

const Parentheses = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8 21s-4-3-4-9 4-9 4-9m8 0s4 3 4 9-4 9-4 9"
    />
  </svg>
);
export default Parentheses;
